import { Component, inject } from '@angular/core';
import { FORM_KEYS, GameFilterService } from '../../../../services/games/game-filter.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-games-filter',
  templateUrl: './games-filter.component.html',
  styleUrls: ['./games-filter.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class GamesFilterComponent {
  gamesFilter = inject(GameFilterService);


  public onFilterClick() {
    this.gamesFilter.updateShowSearchPopup(true);
    this.gamesFilter.toggleFiltersBar();
    this.gamesFilter.state().searchFormMain.reset();
  }
}
